var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetasDireitas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.966,
    height: 16.575,
    viewBox: "0 0 16.966 16.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_FILL0_wght400_GRAD0_opsz48",
    d: "M16.078,24.994a.853.853,0,0,1,0-1.135l6.106-6.106H8.81a.811.811,0,1,1,0-1.621H22.183l-6.106-6.106a.889.889,0,0,1,0-1.162.853.853,0,0,1,1.135,0l7.51,7.51a.823.823,0,0,1,.189.27.793.793,0,0,1,.054.3.83.83,0,0,1-.054.284.783.783,0,0,1-.189.284l-7.51,7.51a.725.725,0,0,1-.567.2A.814.814,0,0,1,16.078,24.994Z",
    transform: "translate(-8 -8.65)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetasDireitas);
export default __webpack_public_path__ + "static/media/setas-direitas.5050ffbf27f91cb533f8ed24da8e2b50.svg";
export { ForwardRef as ReactComponent };